module.exports = __webpack_public_path__ + "static/media/notification.8646c43b.wav";